import React, { useState } from 'react';
import FiltreClasse from '../VueChef/FiltreClasse';
import CardClasse from '../VueChef/CardClasse';

export default function ListClass({classes, handleRowClick}) {
    const [filteredClasses, setFilteredClasses] = useState(classes);

  const computePercentages = (savoirFaires) => {
    const total =
      savoirFaires.nb_vert_plus +
      savoirFaires.nb_vert +
      savoirFaires.nb_vert_pm +
      savoirFaires.nb_yellow +
      savoirFaires.nb_orange +
      savoirFaires.nb_rouge +
      savoirFaires.nb_no_scores;
    return total !== 0 ?
    {
      nb_vert_plus: total ? savoirFaires.nb_vert_plus / total : 0,
      nb_vert: total ? savoirFaires.nb_vert / total : 0,
      nb_vert_pm: total ? savoirFaires.nb_vert_pm / total : 0,
      nb_yellow: total ? savoirFaires.nb_yellow / total : 0,
      nb_orange: total ? savoirFaires.nb_orange / total : 0,
      nb_rouge: total ? savoirFaires.nb_rouge / total : 0,
      nb_no_scores: total ? savoirFaires.nb_no_scores / total : 0,
    }
    :
    0
  };

  const handleFilterChange = (filtered) => {
    setFilteredClasses(filtered);
  };

  return(
    <div>
      {/* Filtre */}
      <FiltreClasse classes={classes} onFilterChange={handleFilterChange} />

      {/* Grid de cards */}
      {filteredClasses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-4 2xl:gap-5 3xl:gap-6 mt-6 xl:mt-4 2xl:mt-5 3xl:mt-6">
          {filteredClasses.map((classItem, index) => {
            const percentages = computePercentages(classItem.savoir_faires);
            return (
              <CardClasse
                key={classItem.id || index}
                classItem={classItem}
                percentages={percentages}
                onRowClick={handleRowClick}
                index={index}
              />
            );
          })}
        </div>
      ) : (
        <div className="text-center py-12 xl:py-8 2xl:py-10 3xl:py-12">
          <p className="text-slate-500 text-lg xl:text-sm 2xl:text-base 3xl:text-lg">Aucune classe ne correspond à vos critères.</p>
        </div>
      )}
    </div>
  )
}